import {
    ActionTypes,
    SecondaryApiTypeEnum,
    doesWorkflowRejectCodeExist,
    getWorkflowRejectCodeMessage
} from '@tassat/common-definitions';
import { IFormValues, SubmitClientUserOpts } from '@tassat/forms/src/ClientUserForm/types';
import { CustomerAddUserReq, CustomerModifyUserReq } from '@tassat/fred-definitions';

import Worker from 'Lib/worker/PrimusWorker';

export const submitClientUser = async (
    values: IFormValues,
    opts: SubmitClientUserOpts,
    handleReqStatusModal?: (values: any) => void
) => {
    const {
        actionType,
        userId,
        firmId,
        setSubmitError,
        onClose,
        firmName,
        initialValues,
        secondaryApiFeatureEnabled
    } = opts;

    if (actionType === ActionTypes.edit && !userId) return;
    const apiSecondaryConnectionTypeEnum = SecondaryApiTypeEnum.FIREBLOCKS;
    let isSecondaryApiEnabled = false;

    if (secondaryApiFeatureEnabled && values.APISecondaryConnectionType) {
        // TODO Update to handle multiple secondary api connections in the future
        isSecondaryApiEnabled = true;
    }

    try {
        let response = { data: undefined };
        if (actionType === ActionTypes.add || actionType === ActionTypes.sso_add) {
            const userValues: Omit<
                CustomerAddUserReq,
                'UUID' |
                'RequestId' |
                'RequesterId' |
                'RequestType' |
                'RequestPattern' |
                'FirmId' |
                'IsApprover' |
                'IsAdminAPIUser' |
                'AdminRoleId'
            > & {
                // Added for Fireblocks, modify for multiple api connections
                APISecondaryConnectionType?: SecondaryApiTypeEnum;
                IsSecondaryApiEnabled?: boolean;
            } = {
                FirstName: values.FirstName,
                LastName: values.LastName,
                Email: values.Email,
                Username: values.Username,
                Phone: values.Phone,
                Notes: values.Notes,
                IsTokenAPIUser: values.IsTokenAPIUser,
                IsAdmin: false,
                APISecondaryConnectionType: isSecondaryApiEnabled ? apiSecondaryConnectionTypeEnum : undefined,
                IsSecondaryApiEnabled: isSecondaryApiEnabled
            };

            if (!isSecondaryApiEnabled || !userValues.APISecondaryConnectionType)
                delete userValues.APISecondaryConnectionType;

            userValues.Email = userValues.Email.trim();
            response = await Worker.getInstance()
                .createUser(firmId, userValues);
        } else if (actionType === ActionTypes.edit) {
            const userValues: Omit<
                CustomerModifyUserReq,
                'UUID' |
                'RequestId' |
                'RequesterId' |
                'FirmId' |
                'ResetPassword' |
                'IsApprover' |
                'IsTwoFactorComplete' |
                'IsTermsOfServiceApproved' |
                'IsAdminAPIUser' |
                'IsFrozen' |
                'IsLocked' |
                'ResetMfa' |
                'AdminRoleId' |
                'EditUsername'
            > & {
                // Added for Fireblocks, modify for multiple api connections
                APISecondaryConnectionType?: SecondaryApiTypeEnum;
                IsSecondaryApiEnabled?: boolean;
            } = {
                UserId: userId,
                FirstName: values.FirstName,
                LastName: values.LastName,
                Email: values.Email,
                Phone: values.Phone,
                Notes: values.Notes,
                IsTokenAPIUser: values.IsTokenAPIUser,
                IsAdmin: false,
                APISecondaryConnectionType: (isSecondaryApiEnabled || initialValues.APISecondaryConnectionType) ?
                    apiSecondaryConnectionTypeEnum : undefined,
                IsSecondaryApiEnabled: isSecondaryApiEnabled
            };

            response = await Worker.getInstance()
                .updateUser(firmId, userValues);
        } else if (actionType === ActionTypes.sso_validate) {
            response = await Worker.getInstance()
                .approveUserSsoPendingRequest({
                    ...values,
                    FirmId: firmId
                });
        }

        if (response.data && response.data.Status === 48) {
            if (actionType === ActionTypes.sso_validate) {
                const statusModalValues = {
                    ...values,
                    firmName
                };
                handleReqStatusModal(statusModalValues);
            } else {
                onClose();
            }
        } else if (response.data && response.data.Status === 49 || response.data.Status < 0) {
            setSubmitError(`Could not ${actionType === ActionTypes.add ? 'add' : 'edit'} user: ${response.data.Reason || 'Something went wrong'}`);
        } else if (response.data && doesWorkflowRejectCodeExist(response.data.Status)) {
            setSubmitError(`Could not ${actionType === ActionTypes.add ? 'add' : 'edit'} user: ${getWorkflowRejectCodeMessage(response.data.Status)}`);
        }
    } catch (error) {
        setSubmitError('Something went wrong');
    }
};